export const environment = {
  production: false,
  pre: false,
  qa: true,

  allowedParentOriginOTP: '$(allowedParentOriginOTP)',
  companyContactEmail: 'warranty@bellross.com',

  apiClient: 'https://clients.bellrossqa.ri.dentsutracking.com/qa',
  mfaClient: 'https://auth.bellrossqa.ri.dentsutracking.com/qa',

  awsMapApiKey: 'v1.public.eyJqdGkiOiIzNjNiYjU0NC01MzZlLTRiM2UtYWJjMC00ZTVhYTBmMmY0OTkifWlOaw3XpUHQgTQr1bsb4wdCacLY2NZm1C9tjwBgg78faa1Bh3RokFSQlmeDo6VMagtgwNmBJJxLYOw_XtThDa0N1-aCNBy7FIKzVZNuX03hqg4ftI4Yahhw3Zcsm86-1sXYJWuYLq_OWB82jhCb-QnyiuiCCNqkLhcVSzeueTVCZmaG1MT8SNUPf2juCJOLtBg5guLp6pN8_Q4EZUxNy8yCAFsCAAvocm094Vdgxbg6ujhy2-ImbK22hehyAxdPpJNxDh6pPF4bGAhS429p5217mtQg3rq1kGECg0ScjY6W3SN3L094awVY5x0qIif1Fxn89noSW0gpYGT8_MPlAjM.ZGQzZDY2OGQtMWQxMy00ZTEwLWIyZGUtOGVjYzUzMjU3OGE4',
  awsRegion: 'eu-west-1',

  dynamsoft: {
    productKey: 'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAwNTAzMjkzLXIxNzM5Mjg3NDYwIiwibWFpblNlcnZlclVSTCI6Imh0dHBzOi8vbWx0cy5keW5hbXNvZnQuY29tLyIsIm9yZ2FuaXphdGlvbklEIjoiMTAwNTAzMjkzIiwic3RhbmRieVNlcnZlclVSTCI6Imh0dHBzOi8vc2x0cy5keW5hbXNvZnQuY29tLyIsImNoZWNrQ29kZSI6NjU1OTIyODg3fQ=='
  }
};
